(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mine-bundle-builder-bf-copy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.mine-bundle').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const products = root.querySelector('.mine-bundle__products');
      const cards = [...root.querySelectorAll('.mine-bundle-card')];
      const slots = [...root.querySelectorAll('[data-slot]')];
      const catalog = root.querySelector('[data-product-catalog]');
      const dialog = root.querySelector('[data-dialog]');
      const options = root.querySelector('[data-dialog-options]');
      const searchInput = root.querySelector('[data-search]');
      const searchResults = root.querySelector('[data-search-results]');
      const searchEmpty = root.querySelector('[data-search-empty]');
      const searchClear = root.querySelector('[data-search-clear]');
      const codeBox = root.querySelector('[data-code-box]');
      const selected = [];
      const formatter = new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency });
      let activeCard = null;
      let activeFamily = 'all';
      let submitting = false;

      cards
        .sort((a, b) => Number(b.dataset.bestSeller === 'true') - Number(a.dataset.bestSeller === 'true'))
        .forEach(card => products.append(card));

      const rate = count => count >= 4 ? .25 : count === 3 ? .2 : count === 2 ? .15 : count === 1 ? .1 : 0;
      const money = cents => formatter.format(cents / 100);
      const toast = textValue => {
        const element = root.querySelector('[data-toast]');
        element.querySelector('p').textContent = textValue;
        element.hidden = false;
        clearTimeout(root.toastTimer);
        root.toastTimer = setTimeout(() => element.hidden = true, 1500);
      };
      const callCatalog = () => {
        catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
        catalog.classList.remove('is-called');
        requestAnimationFrame(() => catalog.classList.add('is-called'));
        setTimeout(() => catalog.focus({ preventScroll: true }), 500);
      };
      const applyFilters = () => {
        cards.forEach(card => {
          const familyMatch = activeFamily === 'all' || (activeFamily === 'best' ? card.dataset.bestSeller === 'true' : card.dataset.family === activeFamily);
          card.hidden = !familyMatch;
        });
      };
      const updateModalCounts = () => {
        options.querySelectorAll('[data-variant-choice]').forEach(choice => {
          const count = selected.filter(item => String(item.variantId) === String(choice.dataset.id)).length;
          const badge = choice.querySelector('[data-variant-count]');
          badge.textContent = count;
          badge.hidden = count === 0;
          choice.classList.toggle('is-selected', count > 0);
        });
      };
      const add = (card, data) => {
        if (selected.length >= 4) {
          render();
          return;
        }
        selected.push({
          productId: card.dataset.productId,
          productHandle: card.dataset.productHandle,
          productTitle: card.dataset.productTitle,
          variantId: data.id,
          variantTitle: data.title,
          price: Number(data.price),
          priceFormatted: data.priceFormatted,
          image: data.image
        });
        render(true);
      };
      const removeOne = card => {
        const index = selected.findLastIndex(item => item.productId === card.dataset.productId);
        if (index > -1) {
          selected.splice(index, 1);
          render();
        }
      };
      const render = celebrate => {
        const count = selected.length;
        const subtotal = selected.reduce((sum, item) => sum + item.price, 0);
        const discount = rate(count);
        const saving = Math.round(subtotal * discount);
        const total = subtotal - saving;
        root.querySelectorAll('[data-count],[data-bar-count]').forEach(element => element.textContent = count);
        root.querySelector('[data-subtotal]').textContent = count ? money(subtotal) : '—';
        root.querySelector('[data-total]').textContent = count >= 1 ? money(total) : '—';
        root.querySelector('[data-saving]').textContent = count >= 1 ? money(saving) : '—';
        const discountCode = count >= 1 ? root.dataset[`code${Math.min(count, 4)}`] : '';
        codeBox.hidden = !discountCode;
        root.querySelector('[data-discount-code]').textContent = discountCode;
        root.querySelector('[data-bar-saving]').textContent = count >= 1 ? `${root.querySelector('.mine-bundle__saving span').textContent} ${money(saving)}` : root.dataset.minimumLabel;
        root.querySelectorAll('[data-tier]').forEach(element => {
          const tier = Number(element.dataset.tier);
          element.classList.toggle('is-unlocked', count >= tier);
          element.classList.toggle('is-current', count === tier);
        });
        const checkout = root.querySelector('[data-checkout]');
        checkout.disabled = count < 1;
        root.querySelector('[data-checkout-label]').textContent = count < 1 ? root.dataset.minimumLabel : root.dataset.continueLabel;
        cards.forEach(card => {
          const productCount = selected.filter(item => item.productId === card.dataset.productId).length;
          const badge = card.querySelector('[data-product-count]');
          card.classList.toggle('is-selected', productCount > 0);
          card.classList.toggle('is-limited', count >= 4);
          badge.textContent = productCount;
          card.querySelector('[data-remove-one]').hidden = productCount === 0;
        });
        slots.forEach((slot, index) => {
          const item = selected[index];
          const empty = slot.querySelector('.mine-bundle__slot-empty');
          const filled = slot.querySelector('.mine-bundle__slot-filled');
          if (item) {
            empty.hidden = true;
            filled.hidden = false;
            const image = filled.querySelector('img');
            image.src = item.image;
            image.alt = item.productTitle;
            slot.querySelector('[data-slot-title]').textContent = item.productTitle;
            slot.querySelector('[data-slot-variant]').textContent = item.variantTitle === 'Default Title' ? '' : item.variantTitle;
            slot.querySelector('[data-slot-price]').textContent = item.priceFormatted;
          } else {
            empty.hidden = false;
            filled.hidden = true;
            slot.querySelector('[data-slot-title]').textContent = '';
            slot.querySelector('[data-slot-variant]').textContent = '';
            slot.querySelector('[data-slot-price]').textContent = '';
          }
        });
        if (celebrate && count >= 1) toast(`${Math.round(discount * 100)}%`);
      };
      const activate = card => {
        if (selected.length >= 4) return;
        activeCard = card;
        options.replaceChildren(card.querySelector('[data-variant-template]').content.cloneNode(true));
        root.querySelector('[data-dialog-title]').textContent = card.dataset.productTitle;
        updateModalCounts();
        dialog.showModal();
      };

      cards.forEach(card => {
        card.querySelector('[data-open-product]').addEventListener('click', () => activate(card));
        const notesDialog = card.querySelector('[data-notes-dialog]');
        card.querySelector('[data-open-notes]').addEventListener('click', () => notesDialog.showModal());
        card.querySelector('[data-close-notes]').addEventListener('click', () => notesDialog.close());
        notesDialog.addEventListener('click', event => {
          if (event.target === notesDialog) notesDialog.close();
        });
        card.querySelector('[data-remove-one]').addEventListener('click', event => {
          event.stopPropagation();
          removeOne(card);
        });
      });
      options.addEventListener('click', event => {
        const choice = event.target.closest('[data-variant-choice]');
        if (!choice || choice.disabled) return;
        add(activeCard, choice.dataset);
        updateModalCounts();
        setTimeout(() => dialog.close(), 220);
      });
      root.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
      slots.forEach((slot, index) => {
        slot.addEventListener('click', event => {
          if (event.target.closest('[data-remove]')) return;
          callCatalog();
        });
        slot.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            callCatalog();
          }
        });
        slot.querySelector('[data-remove]').addEventListener('click', event => {
          event.stopPropagation();
          selected.splice(index, 1);
          render();
        });
      });
      root.querySelectorAll('[data-family-filter]').forEach(button => button.addEventListener('click', () => {
        activeFamily = button.dataset.familyFilter;
        root.querySelectorAll('[data-family-filter]').forEach(item => item.classList.toggle('is-active', item === button));
        applyFilters();
      }));
      const closeSearch = () => {
        searchResults.hidden = true;
        searchEmpty.hidden = true;
      };
      const showSearchResults = () => {
        const query = searchInput.value.trim().toLocaleLowerCase(root.dataset.locale);
        searchClear.hidden = !query;
        searchResults.replaceChildren();
        if (!query) {
          closeSearch();
          return;
        }
        const matches = cards.filter(card => card.dataset.productTitle.toLocaleLowerCase(root.dataset.locale).includes(query)).slice(0, 8);
        searchEmpty.hidden = matches.length > 0;
        searchResults.hidden = matches.length === 0;
        matches.forEach(card => {
          const result = document.createElement('button');
          result.type = 'button';
          result.className = 'mine-bundle__search-result';
          result.setAttribute('role', 'option');
          const image = document.createElement('img');
          image.src = card.dataset.productImage;
          image.alt = '';
          image.width = 58;
          image.height = 68;
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = card.dataset.productTitle;
          const price = document.createElement('small');
          price.textContent = card.dataset.priceLabel;
          copy.append(title, price);
          result.append(image, copy);
          result.addEventListener('click', () => {
            searchInput.value = '';
            searchClear.hidden = true;
            activeFamily = 'all';
            root.querySelectorAll('[data-family-filter]').forEach(item => item.classList.toggle('is-active', item.dataset.familyFilter === 'all'));
            applyFilters();
            closeSearch();
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
            card.classList.add('is-recommended');
            setTimeout(() => {
              card.classList.remove('is-recommended');
              activate(card);
            }, 600);
          });
          searchResults.append(result);
        });
      };
      searchClear.hidden = true;
      searchInput.addEventListener('input', showSearchResults);
      searchInput.addEventListener('focus', showSearchResults);
      searchInput.addEventListener('keydown', event => {
        if (event.key === 'Escape') closeSearch();
      });
      searchClear.addEventListener('click', () => {
        searchInput.value = '';
        searchClear.hidden = true;
        closeSearch();
        searchInput.focus();
      });
      document.addEventListener('click', event => {
        if (!event.target.closest('.mine-bundle__search')) closeSearch();
      });
      root.querySelector('[data-checkout]').addEventListener('click', async () => {
        if (selected.length < 1 || submitting) return;
        const button = root.querySelector('[data-checkout]');
        const label = root.querySelector('[data-checkout-label]');
        const errorMessage = root.querySelector('[data-error]');
        const bundleId = `MINE-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const items = selected.map((item, index) => ({
          id: Number(item.variantId),
          quantity: 1,
          properties: {
            '_MINE Bundle': bundleId,
            '_Bundle position': String(index + 1),
            '_Bundle size': String(selected.length)
          }
        }));
        if (items.some(item => !Number.isFinite(item.id) || item.id <= 0)) {
          errorMessage.textContent = root.dataset.errorLabel;
          errorMessage.hidden = false;
          return;
        }
        submitting = true;
        button.disabled = true;
        label.textContent = root.dataset.addingLabel;
        errorMessage.hidden = true;
        try {
          const cartDrawer = document.getElementById('cart-drawer');
          const cartDrawerTrigger = root.querySelector('[data-cart-drawer-trigger]');
          if (!cartDrawer || !cartDrawerTrigger) throw new Error('The native cart drawer is unavailable');

          const response = await fetch(root.dataset.cartUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error(await response.text());
          await response.json();

          const discountCode = root.dataset['code' + Math.min(selected.length, 4)];
          if (discountCode) {
            try {
              await fetch(
                '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(window.location.pathname),
                { credentials: 'same-origin', redirect: 'follow', cache: 'no-store' }
              );
            } catch (discountError) {
              console.warn('MINE Single Day discount link could not be applied.', discountError);
            }
          }

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          selected.length = 0;
          submitting = false;
          button.hidden = false;
          errorMessage.hidden = true;
          render();
          cartDrawerTrigger.click();
        } catch (error) {
          errorMessage.textContent = root.dataset.errorLabel;
          errorMessage.hidden = false;
          submitting = false;
          button.disabled = false;
          label.textContent = root.dataset.continueLabel;
        }
      });
      applyFilters();
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mine-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.mine-bundle').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const products = root.querySelector('.mine-bundle__products');
      const cards = [...root.querySelectorAll('.mine-bundle-card')];
      const slots = [...root.querySelectorAll('[data-slot]')];
      const catalog = root.querySelector('[data-product-catalog]');
      const dialog = root.querySelector('[data-dialog]');
      const options = root.querySelector('[data-dialog-options]');
      const recommendation = root.querySelector('[data-body-recommendation]');
      const searchInput = root.querySelector('[data-search]');
      const searchResults = root.querySelector('[data-search-results]');
      const searchEmpty = root.querySelector('[data-search-empty]');
      const searchClear = root.querySelector('[data-search-clear]');
      const codeBox = root.querySelector('[data-code-box]');
      const selected = [];
      const formatter = new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency });
      let activeCard = null;
      let activeFamily = 'all';
      let submitting = false;

      cards
        .sort((a, b) => Number(b.dataset.bestSeller === 'true') - Number(a.dataset.bestSeller === 'true'))
        .forEach(card => products.append(card));

      const rate = count => count >= 5 ? .2 : count === 4 ? .18 : count === 3 ? .15 : count === 2 ? .1 : 0;
      const money = cents => formatter.format(cents / 100);
      const toast = textValue => {
        const element = root.querySelector('[data-toast]');
        element.querySelector('p').textContent = textValue;
        element.hidden = false;
        clearTimeout(root.toastTimer);
        root.toastTimer = setTimeout(() => element.hidden = true, 1500);
      };
      const callCatalog = () => {
        catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
        catalog.classList.remove('is-called');
        requestAnimationFrame(() => catalog.classList.add('is-called'));
        setTimeout(() => catalog.focus({ preventScroll: true }), 500);
      };
      const applyFilters = () => {
        cards.forEach(card => {
          const familyMatch = activeFamily === 'all' || (activeFamily === 'best' ? card.dataset.bestSeller === 'true' : card.dataset.family === activeFamily);
          card.hidden = !familyMatch;
        });
      };
      const updateModalCounts = () => {
        options.querySelectorAll('[data-variant-choice]').forEach(choice => {
          const count = selected.filter(item => String(item.variantId) === String(choice.dataset.id)).length;
          const badge = choice.querySelector('[data-variant-count]');
          badge.textContent = count;
          badge.hidden = count === 0;
          choice.classList.toggle('is-selected', count > 0);
        });
      };
      const add = (card, data) => {
        if (selected.length >= 5) {
          render();
          return;
        }
        selected.push({
          productId: card.dataset.productId,
          productHandle: card.dataset.productHandle,
          productTitle: card.dataset.productTitle,
          bodyMatch: card.dataset.bodyMatch,
          bodyTitle: card.dataset.bodyTitle,
          bodyImage: card.dataset.bodyImage,
          bodyUrl: card.dataset.bodyUrl,
          variantId: data.id,
          variantTitle: data.title,
          price: Number(data.price),
          priceFormatted: data.priceFormatted,
          image: data.image
        });
        render(true);
      };
      const removeOne = card => {
        const index = selected.findLastIndex(item => item.productId === card.dataset.productId);
        if (index > -1) {
          selected.splice(index, 1);
          render();
        }
      };
      const renderRecommendation = () => {
        const source = [...selected].reverse().find(item => item.bodyUrl);
        recommendation.hidden = !source;
        if (!source) return;
        const image = recommendation.querySelector('[data-body-image]');
        image.src = source.bodyImage;
        image.alt = source.bodyTitle;
        recommendation.querySelector('[data-body-title]').textContent = source.bodyTitle;
        recommendation.querySelector('[data-body-action]').href = source.bodyUrl;
      };
      const render = celebrate => {
        const count = selected.length;
        const subtotal = selected.reduce((sum, item) => sum + item.price, 0);
        const discount = rate(count);
        const saving = Math.round(subtotal * discount);
        const total = subtotal - saving;
        root.querySelectorAll('[data-count],[data-bar-count]').forEach(element => element.textContent = count);
        root.querySelector('[data-subtotal]').textContent = count ? money(subtotal) : '—';
        root.querySelector('[data-total]').textContent = count >= 2 ? money(total) : '—';
        root.querySelector('[data-saving]').textContent = count >= 2 ? money(saving) : '—';
        const discountCode = count >= 2 ? root.dataset[`code${Math.min(count, 5)}`] : '';
        codeBox.hidden = !discountCode;
        root.querySelector('[data-discount-code]').textContent = discountCode;
        root.querySelector('[data-bar-saving]').textContent = count >= 2 ? `${root.querySelector('.mine-bundle__saving span').textContent} ${money(saving)}` : root.dataset.minimumLabel;
        root.querySelectorAll('[data-tier]').forEach(element => {
          const tier = Number(element.dataset.tier);
          element.classList.toggle('is-unlocked', count >= tier);
          element.classList.toggle('is-current', count === tier);
        });
        const checkout = root.querySelector('[data-checkout]');
        checkout.disabled = count < 2;
        root.querySelector('[data-checkout-label]').textContent = count < 2 ? root.dataset.minimumLabel : root.dataset.continueLabel;
        cards.forEach(card => {
          const productCount = selected.filter(item => item.productId === card.dataset.productId).length;
          const badge = card.querySelector('[data-product-count]');
          card.classList.toggle('is-selected', productCount > 0);
          card.classList.toggle('is-limited', count >= 5);
          badge.textContent = productCount;
          card.querySelector('[data-remove-one]').hidden = productCount === 0;
        });
        slots.forEach((slot, index) => {
          const item = selected[index];
          const empty = slot.querySelector('.mine-bundle__slot-empty');
          const filled = slot.querySelector('.mine-bundle__slot-filled');
          if (item) {
            empty.hidden = true;
            filled.hidden = false;
            const image = filled.querySelector('img');
            image.src = item.image;
            image.alt = item.productTitle;
            slot.querySelector('[data-slot-title]').textContent = item.productTitle;
            slot.querySelector('[data-slot-variant]').textContent = item.variantTitle === 'Default Title' ? '' : item.variantTitle;
            slot.querySelector('[data-slot-price]').textContent = item.priceFormatted;
          } else {
            empty.hidden = false;
            filled.hidden = true;
            slot.querySelector('[data-slot-title]').textContent = '';
            slot.querySelector('[data-slot-variant]').textContent = '';
            slot.querySelector('[data-slot-price]').textContent = '';
          }
        });
        renderRecommendation();
        if (celebrate && count >= 2) toast(`${Math.round(discount * 100)}%`);
      };
      const activate = card => {
        if (selected.length >= 5) return;
        if (Number(card.dataset.variantCount) === 1) {
          add(card, {
            id: card.dataset.singleId,
            title: card.dataset.singleTitle,
            price: card.dataset.singlePrice,
            priceFormatted: card.dataset.singlePriceFormatted,
            image: card.dataset.singleImage
          });
          return;
        }
        activeCard = card;
        options.replaceChildren(card.querySelector('[data-variant-template]').content.cloneNode(true));
        root.querySelector('[data-dialog-title]').textContent = card.dataset.productTitle;
        updateModalCounts();
        dialog.showModal();
      };

      cards.forEach(card => {
        card.querySelector('[data-open-product]').addEventListener('click', () => activate(card));
        card.querySelector('[data-remove-one]').addEventListener('click', event => {
          event.stopPropagation();
          removeOne(card);
        });
      });
      options.addEventListener('click', event => {
        const choice = event.target.closest('[data-variant-choice]');
        if (!choice || choice.disabled) return;
        add(activeCard, choice.dataset);
        updateModalCounts();
        setTimeout(() => dialog.close(), 220);
      });
      root.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
      slots.forEach((slot, index) => {
        slot.addEventListener('click', event => {
          if (event.target.closest('[data-remove]')) return;
          callCatalog();
        });
        slot.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            callCatalog();
          }
        });
        slot.querySelector('[data-remove]').addEventListener('click', event => {
          event.stopPropagation();
          selected.splice(index, 1);
          render();
        });
      });
      root.querySelectorAll('[data-family-filter]').forEach(button => button.addEventListener('click', () => {
        activeFamily = button.dataset.familyFilter;
        root.querySelectorAll('[data-family-filter]').forEach(item => item.classList.toggle('is-active', item === button));
        applyFilters();
      }));
      const closeSearch = () => {
        searchResults.hidden = true;
        searchEmpty.hidden = true;
      };
      const showSearchResults = () => {
        const query = searchInput.value.trim().toLocaleLowerCase(root.dataset.locale);
        searchClear.hidden = !query;
        searchResults.replaceChildren();
        if (!query) {
          closeSearch();
          return;
        }
        const matches = cards.filter(card => card.dataset.productTitle.toLocaleLowerCase(root.dataset.locale).includes(query)).slice(0, 8);
        searchEmpty.hidden = matches.length > 0;
        searchResults.hidden = matches.length === 0;
        matches.forEach(card => {
          const result = document.createElement('button');
          result.type = 'button';
          result.className = 'mine-bundle__search-result';
          result.setAttribute('role', 'option');
          const image = document.createElement('img');
          image.src = card.dataset.productImage;
          image.alt = '';
          image.width = 58;
          image.height = 68;
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = card.dataset.productTitle;
          const price = document.createElement('small');
          price.textContent = card.dataset.priceLabel;
          copy.append(title, price);
          result.append(image, copy);
          result.addEventListener('click', () => {
            searchInput.value = '';
            searchClear.hidden = true;
            activeFamily = 'all';
            root.querySelectorAll('[data-family-filter]').forEach(item => item.classList.toggle('is-active', item.dataset.familyFilter === 'all'));
            applyFilters();
            closeSearch();
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
            card.classList.add('is-recommended');
            setTimeout(() => {
              card.classList.remove('is-recommended');
              activate(card);
            }, 600);
          });
          searchResults.append(result);
        });
      };
      searchClear.hidden = true;
      searchInput.addEventListener('input', showSearchResults);
      searchInput.addEventListener('focus', showSearchResults);
      searchInput.addEventListener('keydown', event => {
        if (event.key === 'Escape') closeSearch();
      });
      searchClear.addEventListener('click', () => {
        searchInput.value = '';
        searchClear.hidden = true;
        closeSearch();
        searchInput.focus();
      });
      document.addEventListener('click', event => {
        if (!event.target.closest('.mine-bundle__search')) closeSearch();
      });
      root.querySelector('[data-checkout]').addEventListener('click', async () => {
        if (selected.length < 2 || submitting) return;
        const button = root.querySelector('[data-checkout]');
        const label = root.querySelector('[data-checkout-label]');
        const errorMessage = root.querySelector('[data-error]');
        const bundleId = `MINE-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const items = selected.map((item, index) => ({
          id: Number(item.variantId),
          quantity: 1,
          properties: {
            '_MINE Bundle': bundleId,
            '_Bundle position': String(index + 1),
            '_Bundle size': String(selected.length)
          }
        }));
        if (items.some(item => !Number.isFinite(item.id) || item.id <= 0)) {
          errorMessage.textContent = root.dataset.errorLabel;
          errorMessage.hidden = false;
          return;
        }
        submitting = true;
        button.disabled = true;
        label.textContent = root.dataset.addingLabel;
        errorMessage.hidden = true;
        try {
          const response = await fetch(root.dataset.cartUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error(await response.text());
          await response.json();
          const discountCode = root.dataset[`code${Math.min(selected.length, 5)}`];
          const redirect = encodeURIComponent(root.dataset.cartPage);
          window.location.href = discountCode ? `/discount/${encodeURIComponent(discountCode)}?redirect=${redirect}` : root.dataset.cartPage;
        } catch (error) {
          errorMessage.textContent = root.dataset.errorLabel;
          errorMessage.hidden = false;
          submitting = false;
          button.disabled = false;
          label.textContent = root.dataset.continueLabel;
        }
      });
      applyFilters();
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mine-wholesale-presentation"] && !Shopify.designMode) return;
  try {
    

(() => {
  const root = document.querySelector('.mine-wholesale-native-page');
  if (!root || root.dataset.motionReady === 'true') return;
  root.dataset.motionReady = 'true';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    root.querySelectorAll('.precompose-title').forEach((item) => item.classList.remove('precompose-title'));
    return;
  }

  const revealSelectors = [
    '.hero-copy > *', '.manifesto-line', '.origin-grid > *', '.creator-grid > *',
    '.craft-title > *', '.craft-gallery figure', '.craft-facts > div', '.center-copy',
    '.journey-grid > *', '.store-copy > *', '.collection-head > *', '.product-feature > *',
    '.product-strip figure', '.beyond-grid > *', '.experience-grid > *', '.shelf-shot',
    '.partner-inner > *', '.partner-values > div', '.finale-copy > *',
    '.mobile-presentation section > *:not(.m-shade):not(.m-partner-backgrounds)',
    '.m-hero-copy > *', '.m-duo > figure', '.m-stats > div', '.m-values > span'
  ].join(',');
  const wordSelectors = '.hero h1, .finale h2, .m-hero h1, .m-finale h2';
  const lateralLeft = '.origin-grid > .tall-photo, .creator-grid > .creator-copy, .journey-grid > .journey-photo, .product-feature > figure, .m-origin > figure, .m-journey > figure';
  const lateralRight = '.origin-grid > .origin-copy, .creator-grid > .portrait-photo, .journey-grid > .journey-copy, .product-feature > div, .m-creator > figure, .m-experience > figure';
  const wordItems = Array.from(root.querySelectorAll(wordSelectors));
  const items = Array.from(root.querySelectorAll(revealSelectors)).filter((item) => !wordItems.includes(item));

  items.forEach((item, index) => {
    item.classList.add('reveal-item');
    item.style.setProperty('--reveal-delay', ((index % 3) * 70) + 'ms');
    if (item.matches('figure, .shelf-shot, .product-feature > figure')) item.classList.add('reveal-visual');
    if (item.matches(lateralLeft)) item.classList.add('reveal-from-left');
    if (item.matches(lateralRight)) item.classList.add('reveal-from-right');
  });

  wordItems.forEach((item) => {
    const textNodes = [];
    const walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    let wordIndex = 0;
    textNodes.forEach((node) => {
      const fragment = document.createDocumentFragment();
      node.data.split(/(\s+)/).forEach((part) => {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }
        const span = document.createElement('span');
        span.className = 'compose-word';
        span.style.setProperty('--word-delay', (wordIndex * 48) + 'ms');
        span.textContent = part;
        fragment.appendChild(span);
        wordIndex += 1;
      });
      node.replaceWith(fragment);
    });
    item.classList.add('word-compose');
    item.classList.remove('precompose-title');
  });

  document.documentElement.classList.add('motion-ready');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
  [...items, ...wordItems].forEach((item) => observer.observe(item));
})();

  } catch(e) { console.error(e); }
})();
})();
